// import base64 from 'base-64';
import engine from 'store/src/store-engine';
import sessionStorages from 'store/storages/sessionStorage';
import plugins from 'store/plugins/expire';
import { wrapFunc, AesEncrypt } from '../../util/js';
import {
  AUTH_LOGIN_DOING,
  AUTH_LOGIN_DONE,
  AUTH_LOGIN_ERR,
  AUTH_LOGOUT_DONE,
} from '../../util/auth';
import { CB_STATUS, cFetch } from '../../util/fetch';
import { PATH_API_AUTH, PATH_API_CIAM_AUTH } from '../../config';
import {
  getDomain, getCiamDomain, getCiamClientId,
  getCiamRedirectUri, getCiamRedirectUriForLogout,
} from '../../util/url';

const sessionStore = engine.createStore(sessionStorages, plugins);
const lang = sessionStore.get('lang') || 'de';
export const actLogout = wrapFunc((dispatch) => {
  dispatch({
    type: AUTH_LOGOUT_DONE,
  });
}, 'actLogout');

export const errCB = (err, inDispatch, cb) => {
  switch (err.status) {
    case CB_STATUS.UNREACH:
      if (cb) cb({ status: CB_STATUS.UNREACH });
      break;
    case CB_STATUS.TIMEOUT:
      if (cb) cb({ status: CB_STATUS.TIMEOUT });
      break;
    case 401:
      if (cb) cb({ status: CB_STATUS.UNAUTH });
      actLogout(inDispatch);
      console.log('401 and redirect to ciam');
      // eslint-disable-next-line max-len
      // window.location.href = `${getCiamDomain()}/v2/logout?client_id=${getCiamClientId()}&post_logout_redirect_uri=${getCiamRedirectUriForLogout()}&lang=${lang}`;
      // edit by sam 20240619 for uat env
      window.location.href = `${getCiamDomain()}/oidc/logout?client_id=${getCiamClientId()}&post_logout_redirect_uri=${getCiamRedirectUriForLogout()}&lang=${lang}`;
      break;
    default:
      if (cb) cb({ status: CB_STATUS.OTHER });
      throw err;
  }
};

export const actLogin = wrapFunc((dispatch, data, cb) => {
  dispatch({
    type: AUTH_LOGIN_DOING,
  });
  const formData = new FormData();
  formData.append('email', AesEncrypt('kyle.yu@wesoft.com'));// data.email
  formData.append('password', '123456');// AesEncrypt(data.password)
  // formData.append('validateCode', AesEncrypt(data.validateCode));
  // formData.append('guid', data.guid);

  return cFetch(getDomain() + PATH_API_AUTH, {
    method: 'POST',
    body: formData,
    credentials: 'same-origin',
  })
    .then((j) => {
      if (j.status === 200) {
        window.sipDomain = j.payload.sip_domain;
        window.newSipDomain = j.payload.new_sip_domain;
        window.oldDeviceLength = j.payload.old_device_length;

        dispatch({
          type: AUTH_LOGIN_DONE,
          payload: {
            email: 'kyle.yu@wesoft.com', // data.email
            token: j.payload.token,
            sipDomain: j.payload.sip_domain,
            kamDomain: j.payload.new_sip_domain,
            deviceLen: j.payload.old_device_length,
          },
        });
        if (cb) cb({ status: CB_STATUS.SUCCESS, payload: j.payload });
      } else {
        throw j;
      }
      return j;
    })
    .catch((err) => {
      dispatch({
        type: AUTH_LOGIN_ERR,
      });
      switch (err.status) {
        case 400:
          if (cb) {
            if ((err.payload && err.payload.detail && err.payload.detail === 'the verification code has expired!')
              || (err.payload && err.payload.detail && err.payload.detail === 'the verification code is incorrect!')) {
              cb({ status: CB_STATUS.VERIFYFAIL });
            } else if (err.payload && err.payload.detail && err.payload.detail === 'The user is locked.') {
              cb({ status: CB_STATUS.ACCOUNTLOCKED });
            } else {
              cb({ status: CB_STATUS.INVALID });
            }
          }
          break;
        default:
          errCB(err, dispatch, cb);
      }
    });
}, 'actLogin');

export const actCiamLogin = wrapFunc((dispatch, data, cb) => {
  dispatch({
    type: AUTH_LOGIN_DOING,
  });
  const formData = new FormData();
  formData.append('ciam_code', data.ciam_code);// AesEncrypt(data.ciam_code)

  return cFetch(getDomain() + PATH_API_CIAM_AUTH, {
    method: 'POST',
    body: formData,
    credentials: 'same-origin',
  })
    .then((j) => {
      if (j.status === 200) {
        window.sipDomain = j.payload.sip_domain;
        window.newSipDomain = j.payload.new_sip_domain;
        window.oldDeviceLength = j.payload.old_device_length;

        dispatch({
          type: AUTH_LOGIN_DONE,
          payload: {
            email: j.payload.email,
            token: j.payload.token,
            sipDomain: j.payload.sip_domain,
            kamDomain: j.payload.new_sip_domain,
            deviceLen: j.payload.old_device_length,
          },
        });
        dispatch({
          type: 'USER_GET_DONE',
          payload: {
            email: j.payload.email || data.email,
            firstName: j.payload.firstName || '',
            lastName: j.payload.lastName || '',
            forceChangePassword: false,
          },
        });
        if (cb) cb({ status: CB_STATUS.SUCCESS, payload: j.payload });
      } else {
        throw j;
      }
      return j;
    })
    .catch((err) => {
      console.log('err=', err);
      dispatch({
        type: AUTH_LOGIN_ERR,
      });
      switch (err.status) {
        case 400:
          console.log('bad request !');
          if (cb) {
            cb({ status: CB_STATUS.INVALID });
          }
          window.location.href = `${getCiamDomain()}/authorize?
          client_id=${getCiamClientId()}
          &scope=openid%20profile%20email&redirect_uri
          =${getCiamRedirectUri()}&response_type=code`;
          break;
        default:
          console.log('execute to default');
          errCB(err, dispatch, cb);
      }
    });
}, 'actCiamLogin');
